import React from 'react';
interface RecommendationsListProps {
  recommendations: Array<{
    title: string;
    description: string;
    impact: string;
    difficulty: 'Easy' | 'Medium' | 'Hard';
    function: string;
  }>;
}
export const RecommendationsList: React.FC<RecommendationsListProps> = ({
  recommendations
}) => {
  const getDifficultyBadge = (difficulty: string) => {
    switch (difficulty) {
      case 'Easy':
        return <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-0.5 rounded" data-id="element-229">
            Easy
          </span>;
      case 'Medium':
        return <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-0.5 rounded" data-id="element-230">
            Medium
          </span>;
      case 'Hard':
        return <span className="bg-red-100 text-red-800 text-xs font-medium px-2 py-0.5 rounded" data-id="element-231">
            Hard
          </span>;
      default:
        return null;
    }
  };
  const getFunctionBadge = (functionName: string) => {
    const colors = {
      sales: 'bg-blue-100 text-blue-800',
      marketing: 'bg-purple-100 text-purple-800',
      operations: 'bg-teal-100 text-teal-800',
      hr: 'bg-orange-100 text-orange-800',
      finance: 'bg-green-100 text-green-800'
    };
    const color = colors[functionName.toLowerCase() as keyof typeof colors] || 'bg-gray-100 text-gray-800';
    return <span className={`${color} text-xs font-medium px-2 py-0.5 rounded capitalize`} data-id="element-232">
        {functionName}
      </span>;
  };
  return <div className="mb-12" data-id="element-233">
      <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-234">
        Top 5 DIY Recommendations
      </h3>
      <p className="text-gray-600 mb-6" data-id="element-235">
        These actionable recommendations are tailored to your business situation
        and can be implemented without external consultants.
      </p>
      <div className="space-y-6" data-id="element-236">
        {recommendations.map((recommendation, index) => <div key={index} className="bg-white rounded-lg border shadow-sm overflow-hidden" data-id="element-237">
            <div className="p-5 flex items-start" data-id="element-238">
              <div className="bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center font-bold flex-shrink-0 mt-0.5 mr-4" data-id="element-239">
                {index + 1}
              </div>
              <div className="flex-grow" data-id="element-240">
                <div className="flex justify-between items-start" data-id="element-241">
                  <h4 className="font-bold text-gray-800 mb-2" data-id="element-242">
                    {recommendation.title}
                  </h4>
                  <div className="flex space-x-2" data-id="element-243">
                    {getDifficultyBadge(recommendation.difficulty)}
                    {getFunctionBadge(recommendation.function)}
                  </div>
                </div>
                <p className="text-gray-700 mb-4" data-id="element-244">
                  {recommendation.description}
                </p>
                <div className="bg-blue-50 p-3 rounded-md" data-id="element-245">
                  <h5 className="text-sm font-medium text-blue-800 mb-1" data-id="element-246">
                    Expected Impact:
                  </h5>
                  <p className="text-sm text-blue-700" data-id="element-247">
                    {recommendation.impact}
                  </p>
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
};